export default {
  container: {
    height: '100%',
    width: '100%',
    padding: '5%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundSize: 'cover',
    backgroundPosition: '50% 50%',
    backgroundRepeat: 'no-repeat'
  },
  clickable: {
    '& $image': {
      cursor: 'pointer'
    }
  },
  image: {
    borderRadius: '8px',
    boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.1)',
    flexBasis: 'auto'
  }
}
